import React from "react";

import "./CampusPage.css";

import janaschool from "./class3.jpg";
import schoolHistoryImg from "./girllll.jpg";

import Footer from "./Footer";

import {
    FaBuilding,
    FaSchool,
    FaArrowRight
} from "react-icons/fa";


import { motion } from "framer-motion";



const CampusPage = () => {


return (

<div className="campus-page">



{/* Hero Section */}

<section

className="campus-hero"

style={{
backgroundImage:`url(${janaschool})`
}}

>


<div className="campus-overlay">


<motion.div

className="campus-title"

initial={{
opacity:0,
y:-50
}}

animate={{
opacity:1,
y:0
}}

transition={{
duration:1
}}

>


<span>

Our Environment

</span>


<h1>
Our Campus
</h1>


<p>

A place where learning,
innovation, and excellence grow.

</p>


</motion.div>



</div>


</section>







{/* Campus Information */}


<section className="campus-information">


<div className="campus-circle circle-one"></div>

<div className="campus-circle circle-two"></div>



<motion.div

className="campus-image-card"

initial={{
opacity:0,
x:-80
}}

whileInView={{
opacity:1,
x:0
}}

transition={{
duration:.8
}}

viewport={{
once:true
}}

>


<img

src={schoolHistoryImg}

alt="School Campus"

/>


<div className="campus-badge">

<FaSchool/>

Modern Learning Campus

</div>



</motion.div>







<motion.div

className="campus-content"

initial={{
opacity:0,
x:80
}}

whileInView={{
opacity:1,
x:0
}}

transition={{
duration:.8
}}

viewport={{
once:true
}}

>



<div className="section-icon">

<FaBuilding/>

</div>



<h2>

A Campus Designed
For Excellence

</h2>



<p>

Nestled in a serene and welcoming environment,
our campus provides modern facilities that inspire
learning, creativity, and personal growth.

</p>



<p>

From comfortable classrooms, technology-driven
learning spaces, and supportive academic
facilities, we create an atmosphere where every
student feels encouraged to discover their potential.

</p>




<button className="campus-btn">

Explore Campus

<FaArrowRight/>

</button>



</motion.div>



</section>





<Footer/>


</div>


);


};


export default CampusPage;